import { render } from "./GroupStart.vue?vue&type=template&id=539311da"
import script from "./GroupStart.vue?vue&type=script&lang=js"
export * from "./GroupStart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__